import { render } from "./CadastroCarreta.vue?vue&type=template&id=4d997aaf&scoped=true"
import script from "./CadastroCarreta.vue?vue&type=script&lang=ts"
export * from "./CadastroCarreta.vue?vue&type=script&lang=ts"

import "./CadastroCarreta.vue?vue&type=style&index=0&id=4d997aaf&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4d997aaf"

export default script